import React from 'react';

import { Iata } from 'types/Search/airport';

import { airportList } from '../../__config/Airports';
import { useAirportAutocompleterState } from '../../__context';
import SingleAirport from '../Airport';
import styles from '../Airport.module.scss';

interface AirportListProps {
    list: Iata[];
    onChange: (entry: Iata) => void;
    idPrefix?: string;
}

const Airport = ({ list, onChange, idPrefix = '' }: AirportListProps) => {
    const airportState = useAirportAutocompleterState();
    const currentValue = new Set(airportState.currentValue);
    return (
        <>
            {list.map((code) => {
                return (
                    <div key={code} className={styles.SubLevel}>
                        <SingleAirport
                            checkbox={{
                                name: code,
                                id: `${idPrefix}${code}`,
                                value: code,
                            }}
                            label={airportList[code]?.label}
                            iataCode={code}
                            key={code}
                            onChange={onChange}
                            isChecked={currentValue.has(code)}
                        />
                    </div>
                );
            })}
        </>
    );
};

export default Airport;
